import { useContext } from 'react';

import DetailElement from 'components/DetailElement';
import { COMPARTMENT_NAMES, WORLD_DIRECTION_NAMES } from 'constants/options';
import { TranslationContext } from 'context/translationContext';
import { calculateInsolation } from 'utils/calculateInsolation';

import styles from './styles.module.scss';
import { Props } from './types';

const RoomDetails = ({ room }: Props) => {
  const { t } = useContext(TranslationContext);
  const compNames: { [k: string]: string } = COMPARTMENT_NAMES(t);
  const roomDirectons: { [k: string]: string } = WORLD_DIRECTION_NAMES(t);

  const buildRoomDirectionElement = (direction: string) => {
    const directions = direction.split(',');

    return (
      <div>
        {directions.map(direction => (
          <div>{roomDirectons[direction]}</div>
        ))}
      </div>
    );
  };

  return (
    <div className={styles.roomWrapper}>
      <div className={styles.roomTitle}>{compNames[room.name]}</div>
      <div className={styles.detailsWrapper}>
        <div className={styles.leftCol}>
          <DetailElement
            caption={t('area')}
            dynamicValue={() => (
              <span>
                {room.area}m<sup>2</sup>
              </span>
            )}
          />
          <DetailElement
            caption={t('flatPerimeter')}
            value={`${room.perimeter} m`}
          />
          {room.insolation ? (
            <DetailElement
              caption={t('insolation')}
              dynamicValue={() => (
                <span>{calculateInsolation(room.insolation || 0)}</span>
              )}
            />
          ) : null}
        </div>
        <div className={styles.rightCol}>
          <DetailElement
            caption={t('floor')}
            value={room.ref_tier.toString()}
          />
          {room.window_area !== 0 ? (
            <DetailElement
              caption={t('windowsArea')}
              value={room.window_area.toString()}
            />
          ) : null}
          {room.exposition ? (
            <DetailElement
              caption={t('worldDirections')}
              dynamicValue={() =>
                buildRoomDirectionElement(room.exposition || '')
              }
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default RoomDetails;
